import { Getter } from 'vuex'
import { NewAttendanceFormState } from './state'

export default {
  /** @type {Getter<NewAttendanceFormState, any>} */
  questions: (state) => state.questions,

  /** @type {Getter<NewAttendanceFormState, any>} */
  answers: (state) => state.answers,

  /** @type {Getter<NewAttendanceFormState, any>} */
  parameters: (state) => state.parameters,

  /** @type {Getter<NewAttendanceFormState, any>} */
  extraAnswers: (state) => state.extraAnswers,

  /** @type {Getter<NewAttendanceFormState, any>} */
  simplified: (state) => state.extraAnswers.simplified,

  /** @type {Getter<NewAttendanceFormState, any>} */
  patientData: (state) => state.patientData,

  /** @type {Getter<NewAttendanceFormState, any>} */
  sideEffects: (state) => state.sideEffects,

  /** @type {Getter<NewAttendanceFormState, any>} */
  disease: (state) => state.disease,

  /** @type {Getter<NewAttendanceFormState, any>} */
  attendance: (state) => state.attendance,

  /** @type {Getter<NewAttendanceFormState, any>} */
  treatments: (state) => state.treatments,

  /** @type {Getter<NewAttendanceFormState, any>} */
  isSaving: (state) => state.isSaving,

  /** @type {Getter<NewAttendanceFormState, any>} */
  isSynced: (state) => state.isSynced,

  /** @type {Getter<NewAttendanceFormState, any>} */
  isFinished: (state) => !!state.attendance.endedAt,

  /** @type {Getter<NewAttendanceFormState, any>} */
  version: (state) => state.version,
}
